import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full py-24 bg-white px-4" data-id="element-173">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-174">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-16 text-center max-w-4xl leading-tight" data-id="element-175">
          Lo que dicen otros estudiantes
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full" data-id="element-176">
          {/* Testimonial 1 */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 flex flex-col hover:-translate-y-2 transition-transform duration-300" data-id="element-177">
            <div className="flex items-center gap-4 mb-6" data-id="element-178">
              <div className="w-14 h-14 rounded-full bg-turquoise/20 flex items-center justify-center text-turquoise font-bold text-xl" data-id="element-179">
                ML
              </div>
              <div data-id="element-180">
                <h3 className="font-bold text-turquoise text-lg" data-id="element-181">
                  María Laura G.
                </h3>
                <p className="text-gray-500 text-sm" data-id="element-182">La Plata, Buenos Aires</p>
              </div>
            </div>
            <div className="flex gap-1 mb-4" data-id="element-183">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-goldenYellow text-goldenYellow" data-id="element-184" />)}
            </div>
            <p className="text-gray-700 italic flex-1" data-id="element-185">
              "Por fin pude organizar todas mis materias sin estrés. El MegaPack
              me cambió la forma de estudiar. Lo empecé un domingo y el lunes ya
              tenía todo planificado."
            </p>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 flex flex-col hover:-translate-y-2 transition-transform duration-300" data-id="element-186">
            <div className="flex items-center gap-4 mb-6" data-id="element-187">
              <div className="w-14 h-14 rounded-full bg-coralOrange/20 flex items-center justify-center text-coralOrange font-bold text-xl" data-id="element-188">
                CR
              </div>
              <div data-id="element-189">
                <h3 className="font-bold text-turquoise text-lg" data-id="element-190">Claudia R.</h3>
                <p className="text-gray-500 text-sm" data-id="element-191">
                  Mar del Plata, Buenos Aires
                </p>
              </div>
            </div>
            <div className="flex gap-1 mb-4" data-id="element-192">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-goldenYellow text-goldenYellow" data-id="element-193" />)}
            </div>
            <p className="text-gray-700 italic flex-1" data-id="element-194">
              "Los templates y guías me ayudaron a cumplir con todas las
              entregas a tiempo. Nunca pensé que organizarme pudiera ser tan
              simple."
            </p>
          </motion.div>

          {/* Testimonial 3 */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 flex flex-col hover:-translate-y-2 transition-transform duration-300" data-id="element-195">
            <div className="flex items-center gap-4 mb-6" data-id="element-196">
              <div className="w-14 h-14 rounded-full bg-softViolet/20 flex items-center justify-center text-softViolet font-bold text-xl" data-id="element-197">
                SM
              </div>
              <div data-id="element-198">
                <h3 className="font-bold text-turquoise text-lg" data-id="element-199">Sergio M.</h3>
                <p className="text-gray-500 text-sm" data-id="element-200">
                  Bahía Blanca, Buenos Aires
                </p>
              </div>
            </div>
            <div className="flex gap-1 mb-4" data-id="element-201">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-goldenYellow text-goldenYellow" data-id="element-202" />)}
            </div>
            <p className="text-gray-700 italic flex-1" data-id="element-203">
              "Las estrategias para exámenes me dieron mucha tranquilidad.
              Llegué al final del cuatrimestre sin el estrés de siempre. Vale
              cada peso."
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}